export const SET_IS_DARK_THEME = "SET_IS_DARK_THEME"
export const SET_IS_LEAVING_PAGE = "SET_IS_LEAVING_PAGE"
